import React from 'react';
import BarChart from './BarChart';
import styled from 'styled-components';

const Container = styled.div`
    display: flex;
    align-items: center;
    margin-top: 4em;
`;

const Graphs = ({ summary }) => {
    const summaryGroup = summary.find((element) => element.id === 'withGroup');
    const summaryWithoutGroup = summary.find((element) => element.id === 'withoutGroup');
    const rateData = [
        {
            name: 'ADR',
            'with Group': parseInt(summaryGroup.adr, 10),
            'without Group': parseInt(summaryWithoutGroup.adr, 10),
        },
        {
            name: 'RevPAR',
            'with Group': parseInt(summaryGroup.revPar, 10),
            'without Group': parseInt(summaryWithoutGroup.revPar, 10),
        },
        {
            name: 'TRevPAR',
            'with Group': parseInt(summaryGroup.trevPar, 10),
            'without Group': parseInt(summaryWithoutGroup.trevPar, 10),
        },
    ];

    const revenueData = [
        {
            name: 'Nett Revenue',
            'with Group': parseInt(summaryGroup.revenue, 10),
            'without Group': parseInt(summaryWithoutGroup.revenue, 10),
        },
        {
            name: 'Spend',
            'with Group': parseInt(summaryGroup.additionalSpend, 10),
            'without Group': parseInt(summaryWithoutGroup.additionalSpend, 10),
        },
        {
            name: 'Gross Revenue',
            'with Group': parseInt(summaryGroup.gross, 10),
            'without Group': parseInt(summaryWithoutGroup.gross, 10),
        },
    ];

    const roomsData = [
        {
            name: 'Rooms',
            'with Group': summaryGroup.rooms,
            'without Group': summaryWithoutGroup.rooms,
        },
    ];

    return (
        <Container>
            <BarChart width="33%" data={rateData} />
            <BarChart width="33%" data={revenueData} />
            <BarChart width="33%" data={roomsData} />
        </Container>
    );
};

export default Graphs;
